import { useEffect, useRef, useState } from "react";
import { X, Check } from "lucide-react";

export default function PromptModal({ title, label, defaultValue = "", placeholder = "", confirmLabel = "Valider", onConfirm, onClose }) {
  const [val, setVal] = useState(defaultValue);
  const ref = useRef(null);
  useEffect(() => { const t = setTimeout(() => ref.current?.focus(), 60); return () => clearTimeout(t); }, []);
  const submit = () => { const v = val.trim(); if (!v) return; onConfirm(v); };
  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={(e) => { e.stopPropagation(); onClose(); }} data-testid="prompt-modal">
      <div className="glass rounded-lg w-full max-w-sm p-5 animate-slidein" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <p className="font-bold text-base">{title}</p>
          <button onClick={onClose} data-testid="prompt-close" className="text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>
        </div>
        {label && <label className="label-mono block mb-1.5">{label}</label>}
        <input ref={ref} value={val} onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } }}
          placeholder={placeholder} data-testid="prompt-input"
          className="w-full bg-secondary/60 border border-border rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#17A2B8]" />
        <div className="flex gap-2 mt-4">
          <button onClick={submit} data-testid="prompt-confirm" className="flex-1 flex items-center justify-center gap-1.5 bg-[#17A2B8] hover:bg-[#1391a5] text-white font-semibold py-2.5 rounded-md text-sm transition-colors"><Check className="w-4 h-4" /> {confirmLabel}</button>
          <button onClick={onClose} data-testid="prompt-cancel" className="px-4 py-2.5 text-sm text-muted-foreground hover:text-foreground">Annuler</button>
        </div>
      </div>
    </div>
  );
}
